import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['timeField'];

  connect() {
    this.checkDisplayPlaceholder();
  }

  focusHandler() {
    this.timeFieldTarget.classList.remove('hide-time-placeholder');
  }

  blurHandler() {
    this.checkDisplayPlaceholder();
  }

  changeHandler() {
    this.checkDisplayPlaceholder();
  }

  checkDisplayPlaceholder() {
    if (!this.timeFieldTarget.value) {
      this.timeFieldTarget.classList.add('hide-time-placeholder');
    } else {
      this.timeFieldTarget.classList.remove('hide-time-placeholder');
    }
  }
}
